import React, { useCallback, useState } from "react";

import {
  convertCurrency,
  convertToUsd,
  getCurrencySymbol,
  getForeignCurrency,
  getMarketplaceCurrencySymbol,
} from "../utils/currency";

const initialState = {
  showGBP: false,
  setShowGBP: (_showGBP) => {},
  convertCurrency: (value) => value,
  convertToUsd: (value) => Number(value),
  getCurrencySymbol: () => "$",
  marketplaceCurrencySymbol: "$",
};
const CurrencyContext = React.createContext(initialState);

function CurrencyProvider({ children, marketplace }) {
  const [foreignSelected, setShowGBP] = useState(false);
  // The picker is only rendered for marketplaces with a local currency, so a
  // choice made on UK/CA/EU must not stay active on a marketplace without one
  // (e.g. US), where nobody can see or undo it.
  const showGBP = foreignSelected && Boolean(getForeignCurrency(marketplace));

  const boundConvertCurrency = useCallback(
    (value, showForeignCurrency = showGBP) =>
      convertCurrency(value, showForeignCurrency, marketplace),
    [marketplace, showGBP]
  );
  const boundConvertToUsd = useCallback(
    (value) => convertToUsd(value, showGBP, marketplace),
    [marketplace, showGBP]
  );
  const boundGetCurrencySymbol = useCallback(
    (showForeignCurrency = showGBP) =>
      getCurrencySymbol(showForeignCurrency, marketplace),
    [marketplace, showGBP]
  );

  return (
    <CurrencyContext.Provider
      value={{
        showGBP,
        setShowGBP,
        convertCurrency: boundConvertCurrency,
        convertToUsd: boundConvertToUsd,
        getCurrencySymbol: boundGetCurrencySymbol,
        marketplaceCurrencySymbol: getMarketplaceCurrencySymbol(marketplace),
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export { CurrencyProvider, CurrencyContext };
